'use client';

import { t } from '@lingui/macro';
import NewReleasesTwoToneIcon from '@mui/icons-material/NewReleasesTwoTone';
import { Box, Button, Tooltip } from '@mui/material';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import {
  type ComponentProps,
  type FC,
  type PropsWithChildren,
  useCallback,
} from 'react';

type Props = Omit<ComponentProps<typeof Button>, 'onClick' | 'href'>;

export const CheckListOpenButton: FC<PropsWithChildren<Props>> = (props) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const onOpen = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('mode', 'analyse');
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  }, [router, pathname, searchParams]);

  return (
    <Box component="div" position="relative">
      {/* TODO: A retiré quand la fonctionnalité ne sera plus nouvelle */}
      <Box component="div" position="absolute" top="-.5rem" right="-.5rem">
        <Tooltip title={t`Nouvelle fonctionnalité`} placement="top">
          <NewReleasesTwoToneIcon color="primary" />
        </Tooltip>
      </Box>
      <Button onClick={onOpen} {...props} />
    </Box>
  );
};
